require('../registration/confirmation/confirmationService');

angular.module('app.passwordReset.passwordResetService', [
  'app.registration.confirmation.confirmationService'
])
  .factory('app.passwordReset.passwordResetService', [
    '$http',
    function ($http) {
      "use strict";

      return {
        sendResetRequest: function (email) {
          return $http.post(window.location.api('sessions/password_reset'), {
            email: email
          });
        },
        getUserByToken: function (token) {
          return $http.get(window.location.api('users_confirm/' + token));
        },
        savePassword: function (email, password, token) {
          return $http.put(window.location.api('users_password'), {
            email: email,
            token: token,
            password: password
          });
        }
      };
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/passwordReset/passwordResetService.js